var i18n = require('i18n');
var lang = i18n('__lang__');
var ajax = require('@enhancer/fe-util-ajax');
var util = require('./util');

module.exports = function (id, config) {
  id = '#tinymce-' + id
  if (!$(id).length) {
    return;
  }

  var opt = {
    selector: id,
    menubar: false,
    statusbar: false,
    paste_data_images: true,
    plugins: [
      "image",
      "textcolor",
      "paste",
      "codesample",
      "fullscreen",
      "preview",
      "link"
      //,"mention"
    ],
    paste_preprocess: function(plugin, args) {
      var match = args.content.match(/src="(file:\/\/[^"]+)/);
      if (match) {
        args.content = '';
        util.show(i18n('img.tip'));
      }
      match = args.content.match(/blob:[^"]+/);
      if (match) {
        var url = match[0];
        var map = {len: 1, count: 0};
        util.getBlob(url, map, function () {
          if (map[url].size > window.enhancerMaxFileSize) {
            var size = window.enhancerMaxFileSize / (1024*1024);
            util.show(i18n('file.size', {size: size}));
            $('.mce-i-undo').click();
          }
        })
      }
    },
    codesample_languages: [
      {text: 'Sql', value: 'sql'},
      {text: 'JavaScript', value: 'javascript'},
      {text: 'Shell', value: 'shell'},
      {text: 'HTML/XML', value: 'markup'},
      {text: 'CSS', value: 'css'}
    ],
    /*
    mentions: {
      queryBy: 'nickname',
      source:  function (query, process, delimiter) {
        if (delimiter === '@') {
          ajax({
            url: '/users',
            data: {
              query: query
            }
          }, function (res) {
            if (res.success) {
              process(res.data)
            }
          });
        }
      },
      insert: function (item) {
        return '<span class="mention-text" data-text="' + item.nickname + '" data-uid="' + item.id + '">@' + item.nickname + '</span>';
      }
    },
    */
    fontsize_formats: "12px 14px 16px 18px 20px 24px 30px 36px 54px 72px",
    content_style: 'body{min-height: 200px;} body.mceContentBody, .mce-content-body {font-size: 14px}',
    toolbar: "undo redo | bold italic sizeselect fontsizeselect | image codesample link | alignleft aligncenter alignright alignjustify | outdent indent | forecolor backcolor | fullscreen preview ",
    autosave_ask_before_unload: false,
    height : 244
  }
  config = config || {};
  for (var i in config) {
    opt[i] = config[i];
  }

  if (lang === 'zh-cn') {
    opt.language = 'zh_cn';
  }
  window.tinymce && tinymce.init(opt);
  $(document).on('click', '.mce-btn[aria-label="Fullscreen"]', function () {
    $(this).closest('.markdown-layer').toggleClass('full');
  });
}


// WEBPACK FOOTER //
// ./src/app/editor.js